"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _StateHelper = _interopRequireDefault(require("../helpers/StateHelper.js"));
var _constants = require("../constants");
var _StaffOrganization = _interopRequireDefault(require("../factories/StaffOrganization.js"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
var stateHelper = new _StateHelper.default(_StaffOrganization.default);
var reducers = {};
reducers[_constants.ORGANIZATIONS_FETCHED] = stateHelper.set;
reducers[_constants.SESSION_RESET] = stateHelper.reset;
reducers[_constants.SESSION_FETCHED] = stateHelper.resetAndSet;
var _default = exports.default = stateHelper.createReducer(reducers);